import React from 'react';
import { IconMagicSearch } from 'site-modules/shared/components/icon-magic-search/icon-magic-search';

import './personalized-search-link-icon.scss';

export const PersonalizedSearchLinkIcon = () => {
  return (
    <span className="gradient-circle bg-cool-gray-90 d-flex align-items-center justify-content-center align-self-start rounded-circle me-1">
      <IconMagicSearch />
    </span>
  );
};
